import React, { useContext, useState, useEffect } from 'react';
import { Col, Row } from 'reactstrap';

import { color } from '~/assets/styles/colors';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Text } from '~/components/Text';
import { ConsultaRevendas } from '../../../components/ExtratoData/ConsultaRevendas';

import { PedidoContext } from '../../../context/PedidoContext';

function Revendas(props) {
	const { user, isMobile } = props;

	const {
		loadingRevenda,
		setLoadingRevenda,
		getRevendas,
		totalItemsRevendas,
		dataRevendas,
		setDataRevendas,
		setLoadingResumo,
		getResumo,
		setDataResumo,
		postSolicitacao,
	} = useContext(PedidoContext);

	const [pagina, setPagina] = useState(1);
	const [filtroPesquisa, setFiltroPesquisa] = useState('');
	const [filtroOrder, setFiltroOrder] = useState('');

	const [expanded, setExpanded] = useState(false);

	const handleChange = (panel) => (event, isExpanded) => {
		setExpanded(isExpanded ? panel : false);
	};

	useEffect(() => {
		getRevendas(pagina, 10, filtroPesquisa, filtroOrder).then(() => setLoadingRevenda(true));
	}, [pagina]);

	const RowCred = (
		<Col>
			<>
				<Text style={{ margin: '0 0 10px 0' }}>REVENDAS</Text>

				<ConsultaRevendas
					isMobile={isMobile}
					user={user}
					pagina={pagina}
					setPagina={setPagina}
					getRevendas={getRevendas}
					loadingRevenda={loadingRevenda}
					filtroPesquisa={filtroPesquisa}
					setFiltroPesquisa={setFiltroPesquisa}
					filtroOrder={filtroOrder}
					setFiltroOrder={setFiltroOrder}
					setLoadingRevenda={setLoadingRevenda}
					dataRevendas={dataRevendas}
					setDataRevendas={setDataRevendas}
					totalItemsRevendas={totalItemsRevendas}
					setLoadingResumo={setLoadingResumo}
					postSolicitacao={postSolicitacao}
					getResumo={getResumo}
					setDataResumo={setDataResumo}
				/>
			</>
		</Col>
	)

	return (
		<>
			{isMobile ?
				<Accordion style={{ margin: '20px 0 20px 0', backgroundColor: color.greenLight }} expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="panel1bh-content"
						id="panel1bh-header"
						style={{ width: '100%', backgroundColor: color.primary }}
					>
						<Typography sx={{ width: '100%', flexShrink: 0 }}>
							<Text>Revendas</Text>
						</Typography>
					</AccordionSummary>
					<Row style={{ padding: '10px' }}>{RowCred}</Row>
				</Accordion>
				:
				<div>
					<Row style={{ padding: '10px' }}>
						{RowCred}
					</Row>
				</div>
			}
		</>
	);
}

export default Revendas;
